export const KlaviyoIcon = () => {
  return (
    <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h32v32H0z" />
      <path
        d="M.647 14.982l14.347-9.504c.564-.36 1.447-.36 2.015 0l14.347 9.505c.859.564.859 1.493 0 2.058l-1.925 1.267a15.903 15.903 0 00-13.441-7.4c-5.658 0-10.614 2.965-13.441 7.4L.623 17.04c-.835-.565-.835-1.514.024-2.059zm15.343-.113c-4.278 0-8.01 2.262-10.136 5.61l3.305 2.196c1.404-2.309 3.913-3.846 6.811-3.846a7.97 7.97 0 016.81 3.846l3.306-2.195a11.857 11.857 0 00-10.096-5.611zm0 7.944c-1.494 0-2.808.839-3.51 2.058l2.22 1.447c.36.294.792.474 1.29.474s.949-.18 1.29-.474l2.219-1.447a4.029 4.029 0 00-3.51-2.058z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="16.001"
          y1="26.795"
          x2="16.001"
          y2="5.208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C21A" />
          <stop offset=".331" stopColor="#93C94B" />
          <stop offset=".486" stopColor="#70C05A" />
          <stop offset=".751" stopColor="#12B259" />
          <stop offset=".903" stopColor="#22AD69" />
          <stop offset="1" stopColor="#22AD69" />
        </linearGradient>
      </defs>
    </svg>
  );
};
